import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router as NgRouter } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ILocation } from 'src/app/interfaces/location';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { Subscription as RxSubscription } from 'rxjs';

import { LocationApiService } from '../../services/location-api-service';
import { LocationDataSource } from '../../services/location-data-source';
import { Location } from 'src/modules/user/types/locations';
import { PageEvent } from '@angular/material/paginator';
import { LocationsEdit } from '../edit/component';

@Component({
    selector: 'location-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LocationsList implements OnInit, OnDestroy {
  public leisureUrl: string = environment.leisureUrl;
  public displayedColumns = ['title', 'actions'];
  public DataSource = new LocationDataSource(
    this.Api,
    'organisation-admin',
    'getUserOrgs',
    this.Organisation
  );
  public Locations: Location[];
  public loading: boolean;
  private Subscriptions: RxSubscription[] = [];
  public PageEvent: PageEvent;

  constructor(
    private dialog: MatDialog,
    protected Router: NgRouter,
    protected Api: LocationApiService,
    protected dialogRef: MatDialogRef<LocationsList>,
    @Inject(MAT_DIALOG_DATA) private Organisation: IOrganisation
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_Locations) => (this.Locations = _Locations)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(() =>
        this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  public editItem(Location?: ILocation) {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = {
      locationId: Location ? Location.id : null,
      Location,
      dataSource: this.DataSource,
    };
    this.dialog.open(LocationsEdit, config);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
